import { useEffect } from "react";

/**
 * FAZ-92 — YATAY ŞERİTTE "DEVAMI VAR" İPUCU.
 *
 * Kullanıcı: "sekmeler genelde çok olduğu için arkada kaybolmasın; bir sonraki
 * sekmenin orada olduğunu görelim, aradaki veya öndeki sekmelerin ucu görünsün."
 *
 * Yatay kayan bir şeritte taşma GÖRÜNMEZDİR: şerit tam kenarda biterse
 * kullanıcı devamı olduğunu anlamaz ve hiç kaydırmaz. Çözüm iki parçalı:
 *   1. Kenarda bir çip KIRPILIR (CSS'teki dolgu bunu sağlar) — "devamı var".
 *   2. Kırpılan çipin üstüne yumuşak bir solma konur — kesik değil, devam.
 *
 * Solma yalnız GERÇEKTEN taşma varken çizilmeli, yoksa hiçbir şeyin olmadığı
 * kenarda gölge görünür ve bu bir hata gibi okunur. Bunu CSS bilemez; ölçüm
 * gerekir. Kap elemanına yazılan `data-tasma` niteliği:
 *   "yok" | "sag" | "sol" | "iki"
 *
 * @param {React.RefObject<HTMLElement>} kapRef  şeridi SARAN eleman
 * @param {string} secici                        şerit seçicisi (kap içinde)
 */
export default function useCipTasma(kapRef, secici = ".applications-tabs") {
  useEffect(() => {
    const kap = kapRef?.current;
    if (!kap) return undefined;
    const serit = kap.querySelector(secici);
    if (!serit) return undefined;

    const olc = () => {
      // 1px tolerans: tarayıcılar kesirli piksel döndürüyor, tam kenarda
      // sonsuz "1px daha var" durumu oluşuyordu.
      const sol = serit.scrollLeft > 1;
      const sag = serit.scrollLeft + serit.clientWidth < serit.scrollWidth - 1;
      const deger = sol && sag ? "iki" : sol ? "sol" : sag ? "sag" : "yok";
      if (kap.dataset.tasma !== deger) kap.dataset.tasma = deger;
    };

    olc();
    serit.addEventListener("scroll", olc, { passive: true });

    // Çip sayısı/dili değişince (sayaç güncellemesi, izin değişimi) yeniden ölç.
    let gozcu = null;
    if (typeof ResizeObserver !== "undefined") {
      gozcu = new ResizeObserver(olc);
      gozcu.observe(serit);
    }
    window.addEventListener("resize", olc);

    return () => {
      serit.removeEventListener("scroll", olc);
      window.removeEventListener("resize", olc);
      if (gozcu) gozcu.disconnect();
    };
  }, [kapRef, secici]);
}
